import EmployeesAdd from './EmployeesAdd';

export default EmployeesAdd;
